<template>
	<footer id="theme-footer" class="footer container margin-top-xl container--large">
		<div class="inner jost font--500">
			<div class=" main-info padding-lg text-center">
				<div class="share-list" v-if="getOptions.social_links.instagram || getOptions.social_links.facebook || getOptions.social_links.youtube"> 
					<h3 class="jost--30">Følg oss</h3>
					<ul class="social-links margin-top-sm margin-bottom-md">
						<li class="item facebook"><a v-if="getOptions.social_links.facebook" :href="getOptions.social_links.facebook" rel="noopener" target="_blank" v-html="icons.facebook" /></li>
						<li class="item instagram"><a v-if="getOptions.social_links.instagram" :href="getOptions.social_links.instagram" rel="noopener" target="_blank" v-html="icons.instagram" /></li>
						<li class="item youtube"><a v-if="getOptions.social_links.youtube" :href="getOptions.social_links.youtube" rel="noopener" target="_blank" v-html="icons.youtube" /></li>
					</ul>
				</div>
				<div class="footer-extras margin-bottom-lg" v-if="getOptions.footer && getOptions.footer.footer_text">
					<div class="footer-text" v-html="getOptions.footer.footer_text" v-if="getOptions.footer.footer_text"></div>
				</div>
				<WpLink v-if="policyPage" class="jost--18 slide-hover slide-hover--white slide-hover--tiny" :url="policyPage.slug" :title="policyPage.name">{{policyPage.name}}</WpLink>
			</div>
			<div class="cpr-footer text-center jost--18">
				<p>Nettside levert av <a target="_blank" class="slide-hover slide-hover--tiny" rel="noopener author" href="//tankenbak.no">Tanken Bak</a></p>
			</div>
		</div>
	

	</footer>
</template>


<script> 
import WpLink from '@/components/elements/WpLink';
import Button from '@/components/elements/Button'

import { instagram, youtube, facebook } from '@/components/../icons';
import { mapGetters } from 'vuex';

export default {
	name : 'theme-footer',
	components: {
		WpLink,
		Button
    },
    data(){
        return{
					wpvue : window.WPVUE,
        }
    },
    computed: {
      	...mapGetters([
        	'getOptions'
		]),
			policyPage(){
				return this.wpvue.wp_page_for_privacy_policy_page || false
			},
			icons(){
				const icons = {
					facebook : facebook(),
					youtube : youtube(),
					instagram: instagram()
				}
				return icons
			}
	},
	methods:{
		
	}	
}
</script>

 
<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss'; 

#theme-footer{
	a{
		text-decoration: none;
	}
	.inner{
		h3{
			margin: 0;
		}
	}
	.social-links{
		padding: 0;
		display: flex;
		justify-content: center;
		li{
			margin-left: 7px;
			margin-right: 7px;
			list-style: none;
			svg{
				rect{
					fill: #fff;
					transition: fill 0.2s ease-in-out;
				}
				path{
					fill: $dark;
					transition: fill 0.2s ease-in-out;
				}
			}
			a{
				&:hover{
					svg{
						rect{
							fill: $green;
						}
						path{
							//fill: #fff
						}
					}
				}
			}
			@include mquery($phone){
				svg{
					width: 30px;
					height: 30px;
				}
			}
		}
	}
	.main-info{
		background-color: $dark;
		color: #fff;
	}
}

</style>